import "./country-selector.scss";
import cookie from "../../modules/cookie";
import languageListTemplate from "./CountrySelector.hbs";
import notificationTemplate from "../Notifications/Notifications.hbs";
import axios from "axios";

(function () {
    if (document.querySelectorAll(".js-country-selector").length > 0) {

        const countrySelector = {
            store: {
                data: [],
                userLanguage: "",
            },
            init: function () {
                this.fetchData();
            },
            fetchData: () => {

                axios
                    .get("/api/countries/GetCountries", {
                        params: {
                            url: window.location.href,
                        },
                    })
                    .then(function (response) {
                        countrySelector.store.data = response.data.countries;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .finally(function () {
                        countrySelector.renderTemplate();
                    });
            },
            renderTemplate: () => {
                const target = document.querySelector(".js-country-selector");

                target.innerHTML = languageListTemplate(countrySelector.store.data);

                countrySelector.fetchContryData();
            },
            fetchContryData: () => {
                axios
                    .get("/api/notification/GetCountry")
                    .then(function (response) {
                        if (response.data !== "Not_Found") {
                            const activeCountry = countrySelector.store.data.filter(
                                (country) => {
                                    const menu = country.languages.some(
                                        () => country.active == true
                                    );
                                    return menu;
                                }
                            );
                            if (activeCountry[0].countryTitle === "Securitas.com") {
                                const currentCountry = response.data;
                                const countriesArray = [];
                                const cookieLang = cookie.getCookie("NotificationPopup");

                                const matchingCountries = countrySelector.store.data.filter(
                                    (country) => country.countryCode === currentCountry
                                );

                                if (matchingCountries.length > 0) {
                                    matchingCountries.forEach((country) => {
                                        country.languages.forEach((language) => {
                                            if (!cookieLang.includes(language.code)) {
                                                countriesArray.push(country);
                                            }
                                        });
                                    });

                                    if (countriesArray.length > 0) {
                                        countrySelector.renderNotification(
                                            countriesArray
                                        );
                                    }
                                }
                            }
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            renderNotification: (countries) => {
                const target = document.getElementById("notifications");

                target.innerHTML = notificationTemplate(countries);

                countrySelector.closeNotification();
            },
            closeNotification: () => {
                const closeButtons = document.querySelectorAll(".notification__close");

                closeButtons.forEach((closeButton) => {
                    closeButton.addEventListener("click", function (e) {
                        const cookieLanguageNotification = cookie.getCookie(
                            "NotificationPopup"
                        );
                        e.target.parentNode.remove();

                        if (cookieLanguageNotification == "") {
                            const arr = [];
                            arr.push(e.target.dataset.code);
                            cookie.setCookie("NotificationPopup", arr, 30);
                        } else {
                            const cookieValue = cookie.getCookie("NotificationPopup");
                            const arr = cookieValue.split(",");
                            arr.push(e.target.dataset.code);
                            cookie.setCookie("NotificationPopup", arr, 30);
                        }
                    });
                });
            },
        };       
        countrySelector.init();
    }
})();
